(function () {
  var CARD_SECTION_ID = 'et-recommended-card';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* The request is a byte-for-byte mirror of what the Rebuy app block puts on
     the live page:

       <div data-rebuy-id="160785" data-rebuy-shopify-product-ids="<product>">

     i.e. the viewed product and nothing else. Two things used to be sent on top
     of that and both changed the answer:

       - cart product/variant ids. Rebuy treats every id as an input, so a
         non-empty cart pulled the recommendations away from what the live
         widget shows. That is exactly why the lists matched sometimes and not
         others.
       - an explicit limit. The source does not simply truncate: asked with no
         limit it returns 5 products for the wrist trainer, asked with limit=6 it
         returns 6, and the sixth is back-filled by fallback logic. Forcing a
         limit therefore changes WHICH products come back, not just how many.

     So neither is sent any more, and cfg.limit is only a display cap applied
     after the fact — it can trim the list, never pad it. */
  function fetchRecommendations(cfg) {
    var params = '?key=' + encodeURIComponent(cfg.key);
    if (cfg.productId) {
      params += '&shopify_product_ids=' + encodeURIComponent(cfg.productId);
    }

    var url = cfg.sourceId
      ? 'https://rebuyengine.com/api/v1/custom/id/' + encodeURIComponent(cfg.sourceId) + params
      : 'https://rebuyengine.com/api/v1/products/recommended' + params;

    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Rebuy HTTP ' + response.status);
      return response.json();
    });
  }

  function fetchCard(handle) {
    var url = routesRoot() + 'products/' + handle + '?section_id=' + CARD_SECTION_ID;
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        return section ? section.innerHTML : '';
      })
      .catch(function () {
        return '';
      });
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback(true);
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback(true);
      } else if (attempts > 100) {
        clearInterval(timer);
        callback(false);
      }
    }, 50);
  }

  function initSlider(rootEl) {
    var swiperEl = rootEl.querySelector('.et-rec__swiper');
    if (!swiperEl) return;

    whenSwiperReady(function (available) {
      if (!available) {
        swiperEl.classList.add('et-rec__swiper--fallback');
        rootEl.removeAttribute('hidden');
        return;
      }

      var options = {
        slidesPerView: parseFloat(swiperEl.dataset.slidesMobile) || 1.6,
        spaceBetween: 16,
        breakpoints: {
          750: { slidesPerView: 3 },
          990: { slidesPerView: parseFloat(swiperEl.dataset.slidesDesktop) || 4 }
        }
      };

      var prev = rootEl.querySelector('.et-rec__arrow--prev');
      var next = rootEl.querySelector('.et-rec__arrow--next');
      if (prev && next) {
        options.navigation = { prevEl: prev, nextEl: next };
      }

      var scrollbar = rootEl.querySelector('.et-rec__scrollbar');
      if (scrollbar) {
        options.scrollbar = { el: scrollbar, draggable: true };
      }

      new Swiper(swiperEl, options);
      rootEl.removeAttribute('hidden');
    });
  }

  function init(rootEl) {
    if (rootEl.hasAttribute('data-et-rec-init')) return;
    rootEl.setAttribute('data-et-rec-init', '');

    var key =
      rootEl.dataset.apiKey ||
      (window.Rebuy && window.Rebuy.shop && window.Rebuy.shop.api_key) ||
      '';
    if (!key) return;

    var list = rootEl.querySelector('[data-et-rec-list]');
    if (!list) return;

    var cfg = {
      key: key,
      sourceId: rootEl.dataset.sourceId || '',
      productId: rootEl.dataset.productId || '',
      // 0 / unset means "show everything Rebuy returned", which is what keeps
      // the list identical to the live widget
      limit: parseInt(rootEl.dataset.limit, 10) || 0
    };

    fetchRecommendations(cfg)
      .then(function (json) {
        var products = (json && json.data) || [];
        var seen = {};
        var handles = [];
        products.forEach(function (product) {
          if (!product || !product.handle || seen[product.handle]) return;
          if (cfg.productId && String(product.id) === cfg.productId) return;
          seen[product.handle] = true;
          handles.push(product.handle);
        });
        if (cfg.limit > 0) handles = handles.slice(0, cfg.limit);
        if (!handles.length) throw new Error('No recommendations');
        return Promise.all(handles.map(fetchCard));
      })
      .then(function (cards) {
        var html = cards
          .filter(Boolean)
          .map(function (card) {
            return '<div class="swiper-slide et-rec__slide">' + card + '</div>';
          })
          .join('');
        if (!html) throw new Error('No cards rendered');
        list.innerHTML = html;
        initSlider(rootEl);
      })
      .catch(function () {
        // Storefront: section stays hidden. Editor: the root is never hidden,
        // so the header remains visible for configuration.
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-et-rec]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-et-rec]')) {
      initAll(event.target);
    }
  });
})();
